// @ts-strict-ignore
import {Injectable, Injector} from "@angular/core";
import {SimEnumService} from "../../../api/generated/service";
import {AudioDeviceIconType, CameraLayoutType, CameraLayoutMap} from "@models";

@Injectable({
	providedIn: "root",
})
export class SimEnumExtendedService extends SimEnumService {
	constructor(injector: Injector) {
		super(injector);
	}

	public getMaxScreenCountForCameraLayoutType(cameraLayoutType: CameraLayoutType): number {
		return Math.max(1, CameraLayoutMap?.get(cameraLayoutType)?.svgs?.size - 1);
	}

	public getFontIcon(audioChannelIcon: AudioDeviceIconType) {
		switch (audioChannelIcon) {
			case AudioDeviceIconType.iconXLR:
				return "fa-microphone"; // SVG
			case AudioDeviceIconType.CAM:
				return "fa-cctv";
			case AudioDeviceIconType.Microphone:
				return "fa-microphone";
			case AudioDeviceIconType.Telephone:
				return "fa-phone-alt";
			case AudioDeviceIconType.Trainer:
				return "fa-user-headset";
			case AudioDeviceIconType.VOG:
				return "fa-bullhorn";
			case AudioDeviceIconType.VTP:
				return "fa-user-injured"; // SVG
			case AudioDeviceIconType.WirelessMic:
				return "fa-user-headset";
			default:
				return "fa-microphone";
		}
	}

	public containsFlags(enumValue: number, ...args: number[]): boolean {
		if (args && args.length > 0) {
			let combinedComparisonValues = 0;
			args.forEach((value) => {
				combinedComparisonValues |= value;
			});

			return (enumValue & combinedComparisonValues) === combinedComparisonValues;
		} else {
			return false;
		}
	}
}
